import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { DataUrlModuleType } from './types';

const initialState: DataUrlModuleType = {};

/**
 * We cannot update any module state directly as because module data is in an array any updates would cause all modules to re-render
 * and cause a performance hit. Instead we need to update the module data url in the redux state and then use that to identify any changes
 */

export const modulesDataUrlsSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {
    REDUX_MODULE_DATAURL_SET: (
      state,
      action: PayloadAction<{
        module: IModuleConfig;
        dataUrl: string | undefined;
      }>,
    ) => {
      const { dataUrl, module } = action.payload;
      if (dataUrl) {
        const newState = {
          ...state,
          [dataUrl]: {
            key: dataUrl,
            status: 'loaded' as const,
            data: module,
          },
        };
        return newState;
      }
      return state;
    },
    REDUX_MODULE_DATAURL_CLEAR: () => {
      return initialState;
    },
  },
});

export const { REDUX_MODULE_DATAURL_SET, REDUX_MODULE_DATAURL_CLEAR } = modulesDataUrlsSlice.actions;

export const moduleDataUrsReducer = modulesDataUrlsSlice.reducer;
